import { QueryObserverOptions } from "@tanstack/react-query"

import { PracticeSearchPageRequest } from "@shared/zod/schemas/requests/practicePage"
import { PracticePublicResponse, VerifyPostalCodeResponse } from "@shared/zod/schemas/responses/practice"
import { PagePublicResponse } from "@shared/zod/schemas/responses/practicePage"
import { PracticeSearchResponse } from "@shared/zod/schemas/responses/practiceSearch"

import { axiosPublic } from "./generic/AxiosInterceptor/AxiosInterceptor"

// Sets defaults used in `buildApiFromServices`
export const queryOptions: Partial<QueryObserverOptions> = {
  staleTime: 15 * 60 * 1000, // 15 minutes
  refetchOnMount: false,
}

export const get = async (
  query: Pick<PracticeSearchPageRequest, "search" | "limit" | "careGroupId">
): Promise<PracticeSearchResponse[]> => {
  const resp = await axiosPublic({
    url: `/public/practices`,
    method: "get",
    params: query,
  })

  return resp.data ?? []
}

export const getBySlug = (practiceSlug: string): Promise<PracticePublicResponse> => {
  return axiosPublic({
    url: `/public/practices/${practiceSlug}`,
    method: "get",
  }).then((resp) => resp.data)
}

export const getAllPages = (practiceSlug: string): Promise<PagePublicResponse[]> => {
  return axiosPublic({
    url: `/public/practices/${practiceSlug}/pages`,
    method: "get",
  }).then((resp) => resp.data)
}

export const getPage = (
  practiceSlug: string,
  pageSlug: string,
  invitation: string | undefined
): Promise<PagePublicResponse> => {
  return axiosPublic({
    url: `/public/practices/${practiceSlug}/pages/${pageSlug}`,
    method: "get",
    params: invitation ? { invitation } : undefined,
  }).then((resp) => resp.data)
}

export const verifyPostalCode = (
  practiceSlug: string,
  postalCode: string,
  houseNumber: number,
  houseNumberAddition: string | undefined
): Promise<VerifyPostalCodeResponse> => {
  return axiosPublic({
    url: `/public/practices/${practiceSlug}/postalcode/${postalCode}/${houseNumber}`,
    params: {
      ...(houseNumberAddition && { houseNumberAddition }),
    },
    method: "get",
  }).then((resp) => resp.data)
}
